<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2023-10-11 14:46:57
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2023-12-06 18:11:05
 * @FilePath: /seller.sviptrader.com/src/views/configure/rulesManage/list/components/talentClue/components/distribute.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="distribute-wrapper" v-loading="loading">
		<div class="operate-wrapper">
			<el-button type="primary" @click="addAccount" v-auth="['configure:rules:talentClue:account:add']">新增账号</el-button>
			<span class="font-h6-regular yx-color-text-secondary ml-12">被添加子账号下载安装软件后将参与到 [自动筛选获取达人] 任务</span>
		</div>
		<div class="content mt-16">
			<RdPureCheckGroup :data="list" :groupSize="4">
				<div slot-scope="{ item, active }" class="fuc-item font-h4-regular" :class="active ? 'active yx-color-primary' : 'yx-color-text-regular'">
					<div class="main-content">
						<div class="title flex-row-align-center">
							<rd-text :width="114" class="font-h6-medium">{{ item.nickname }}</rd-text>
							<template v-if="item.runStatus === ACCOUNT_NOT_ENABLED">
								<i class="red-icon"></i>
								<el-tooltip
									:open-delay="300"
									:disabled="!tooltipstopReasonTypeMap[item.stopReasonType]"
									effect="dark"
									:content="
										item.stopReasonType
											? `未开启自动获取达人任务(因${tooltipstopReasonTypeMap[item.stopReasonType]}导致任务关闭)`
											: '未开启自动获取达人任务'
									"
									placement="top"
								>
									<span class="stop-wrapper yx-color-text-regular font-h6-regular">
										{{ accountStatusMap[item.runStatus] }}
										<i class="el-icon-arrow-right"></i>
									</span>
								</el-tooltip>
							</template>
						</div>
						<div class="font-h6-regular yx-color-text-secondary">手机号：{{ item.mobile }}</div>
					</div>
					<el-button class="remove-btn" size="mini" @click="deleteItem(item)" v-auth="['configure:rules:talentClue:account:del']">移除</el-button>
				</div>
			</RdPureCheckGroup>
		</div>
		<ChooseUserDrawer :selectable="selectableHandle" ref="chooseUserDrawer" @selectChange="selectChangeFn"></ChooseUserDrawer>
	</div>
</template>

<script>
import ChooseUserDrawer from '@/components/business/chooseUserDrawer';
import { accountRemove, accountList, accountAdd } from '@/api/settings.js';
import { tooltipstopReasonTypeMap, ACCOUNT_NOT_ENABLED, accountStatusMap } from '../const';

export default {
	data() {
		return {
			tooltipstopReasonTypeMap,
			accountStatusMap,
			ACCOUNT_NOT_ENABLED,
			mode: 'search',
			ruleDialogVisible: false,
			distributeType: '',
			loading: false,
			list: [],
			disabledList: [],
		};
	},
	components: {
		ChooseUserDrawer,
	},
	created() {
		this.getAccountList();
	},
	methods: {
		selectableHandle(row) {
			// 已经停用和删除的禁用
			return !this.disabledList.includes(row.id) && row.use_status !== '2' && !row.deleted;
		},
		async getAccountList() {
			try {
				this.loading = true;
				const { list } = await accountList({
					platformId: dataMap.PLATFORM_DY.value,
				});
				this.list = list;
				this.disabledList = list.map(({ userId }) => userId);
			} finally {
				this.loading = false;
			}
		},
		deleteItem(item) {
			this.$modal({
				title: '确认移除该账号？',
				content: '被移除账号不能执行自动获取达人任务，确认要移除么？',
				size: 'small',
				btns: [
					{
						type: 'default',
						text: '取消',
						key: 'cancel',
					},
					{
						type: 'primary',
						text: '确认移除',
						key: 'confirm',
					},
				],
			})
				.then(res => {
					if (res.key == 'confirm') {
						this.accountRemove(item.id);
						res.done();
					} else {
						res.done();
					}
				})
				.catch(() => {});
		},
		async accountRemove(id) {
			await accountRemove({
				id,
			});
			this.$message.success('移除成功');
			this.getAccountList();
		},
		addAccount() {
			this.$refs.chooseUserDrawer.show();
		},
		async selectChangeFn(list) {
			if (!list?.length) {
				this.$message.warning('请选择员工');
				return;
			}
			try {
				this.loading = true;
				await accountAdd({
					platformId: dataMap.PLATFORM_DY.value,
					userIds: list.map(item => item.id),
				});
				this.$message.success('新增成功');
				this.getAccountList();
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.fuc-item {
	padding: 20px 16px;
	border: 1px solid @color-gy3;
	border-radius: 8px;
	position: relative;

	.main-content {
		margin-right: 90px;
	}

	.stop-wrapper {
		flex-shrink: 0;
	}

	.red-icon {
		display: inline-block;
		height: 6px;
		width: 6px;
		flex-shrink: 0;
		border-radius: 3px;
		background: #fa2714;
		margin-left: 8px;
		margin-right: 6px;
	}

	.remove-btn {
		position: absolute;
		top: 24px;
		right: 20px;
	}
}
</style>
